// Stripe Checkout（与 hwm_web-master 一致：动态加载 Stripe.js + redirectToCheckout）
import { markStripeRedirectStart } from '@/utils/stripeHistoryFix'
const STRIPE_JS_SRC = 'https://js.stripe.com/v3/'
let stripeJsLoadingPromise = null
export function loadStripeJs() {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('Stripe payment is only supported in a browser environment'))
  }
  if (window.Stripe) return Promise.resolve()
  if (stripeJsLoadingPromise) return stripeJsLoadingPromise
  stripeJsLoadingPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${STRIPE_JS_SRC}"]`)
    if (existing) {
      existing.addEventListener('load', () => resolve())
      existing.addEventListener('error', () => reject(new Error('Failed to load Stripe.js')))
      return
    }
    const script = document.createElement('script')
    script.src = STRIPE_JS_SRC
    script.async = true
    script.onload = () => resolve()
    script.onerror = () => reject(new Error('Failed to load Stripe.js'))
    document.head.appendChild(script)
  })
  return stripeJsLoadingPromise
}
export function getStripePublishableKey() {
  // Vue CLI 环境变量必须以 VUE_APP_ 开头
  return (
    process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY ||
    process.env.VUE_APP_STRIPE_PUBLISHABLE ||
    process.env.VUE_APP_STRIPE_PK ||
    ''
  )
}
export function getAbsoluteHashUrl(hashPathAndQuery) {
  // 优先使用环境变量配置的前端基础地址
  const envBaseUrl = process.env.VUE_APP_FRONTEND_BASE_URL
  if (envBaseUrl) {
    // 确保基础地址以 /# 或 # 结尾
    const base = envBaseUrl.endsWith('#') ? envBaseUrl : (envBaseUrl.endsWith('/#') ? envBaseUrl : envBaseUrl + '/#')
    const path = String(hashPathAndQuery || '').replace(/^[#/]+/, '')
    return `${base.replace(/#$/, '')}#/${path}`
  }
  // 兼容部署在子目录以及 /index.html
  const origin = window.location.origin
  const pathname = (window.location.pathname || '/').replace(/\/index\.html$/i, '/')
  const base = origin + pathname
  const hash = String(hashPathAndQuery || '').startsWith('#') ? String(hashPathAndQuery || '')
    : `#${String(hashPathAndQuery || '')}`
  return `${base}${hash}`
}
export async function redirectToStripeCheckoutBySessionId(sessionId) {
  if (!sessionId) throw new Error('Missing checkout_session_id; cannot redirect to payment')
  const publishableKey = getStripePublishableKey()
  if (!publishableKey) {
    throw new Error('Missing Stripe Publishable Key (please set VUE_APP_STRIPE_PUBLISHABLE_KEY)')
  }
  // Mark before navigation so we can remove Stripe from the back stack after returning.
  markStripeRedirectStart()
  await loadStripeJs()
  if (!window.Stripe) throw new Error('Stripe.js did not load correctly')
  const stripe = window.Stripe(publishableKey)
  const { error } = await stripe.redirectToCheckout({ sessionId })
  if (error) {
    throw new Error(error.message || 'Failed to redirect to Stripe Checkout')
  }
}
export async function startStripeCheckout({ checkoutUrl, sessionId }) {
  // 后端若直接返回 checkout_url，则优先使用
  if (checkoutUrl) {
    // Mark before navigation so we can remove Stripe from the back stack after returning.
    markStripeRedirectStart()
    window.location.href = checkoutUrl
    return
  }
  await redirectToStripeCheckoutBySessionId(sessionId)
}
